var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Creates a promise and returns the new promise and its associated resolve function
 */
export var createPromisePair = function () {
    var resolve;
    var promise = new Promise(function (res) {
        resolve = res;
    });
    return [promise, resolve];
};
/**
 * Splits an event object into a tuple of event name and the rest of the event data.
 */
export function eventToTuple(event) {
    var eventName = event.eventName, rest = __rest(event, ["eventName"]);
    return [eventName, rest];
}
